import * as React from 'react';
import { IInvoiceRow } from '../../../models/IInvoice';
import { Table } from 'soprasteria-ui-library';
import { dateTimeToDateString } from '../../../helpers/DateHelper';
import { Link } from 'react-router-dom';
import { PATIENT, EMERGENCY_TREATMENT, REFERRAL, ORTHODONTIC_REFERRAL, RISK_POT_REPORT } from '../../../utils/RouteConstants';
import { formatPersonalSecurityNumberAndOrganisationNumber } from "../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";
import { formatCurrency } from '../../../helpers/CurrencyHelper';

interface IInvoiceRowsTable {
    invoiceRows: IInvoiceRow[];
}

export const InvoiceRowsTable: React.FunctionComponent<IInvoiceRowsTable> = ({ invoiceRows }) => {

    const renderEntityLink = (invoiceRow: IInvoiceRow) => {
        const entityTypeQuery = getEntityTypeQuery(invoiceRow);
        return <Link to={`/${PATIENT}/${invoiceRow.patientGuidId}/${entityTypeQuery}`}>{invoiceRow.entityNumber}</Link>
    }

    const getEntityTypeQuery = (invoiceRow: IInvoiceRow) => {
        if (invoiceRow.emergencyTreatmentId) {
            return `${EMERGENCY_TREATMENT}/${invoiceRow.emergencyTreatmentId}`;
        }
        else if (invoiceRow.referralId) {
            return `${REFERRAL}/${invoiceRow.referralId}`;
        }
        else if (invoiceRow.orthodonticReferralId) {
            return `${ORTHODONTIC_REFERRAL}/${invoiceRow.orthodonticReferralId}`;
        }
        else if (invoiceRow.riskPotReportId) {
            return `${RISK_POT_REPORT}/${invoiceRow.riskPotReportId}`;
        }
        else {
            return null;
        }
    }

    const showEntityColumn = () => {
        return invoiceRows.some(data => data.entityNumber !== "");
    }

    const renderSelectionAreaColumns = () => {
        return !invoiceRows.some((row) => row.description === undefined);
    }

    return (
        <Table>
            <thead>
                <tr>
                    {
                        renderSelectionAreaColumns() ?
                            <>
                                <th>Beskrivning</th>
                                <th className="text-right">Summa</th>
                            </>
                            :
                            <>
                                <th>Åtgärdsdatum</th>
                                {
                                    showEntityColumn() ?
                                        <th>Ärendenummer</th>
                                        : null
                                }
                                <th>Personnummer</th>
                                <th>Åtgärdskod</th>
                                <th className="text-right">à-pris</th>
                                <th style={{width: "12%"}} className="text-right">Fakturerat belopp</th>
                            </>
                    }
                </tr>
            </thead>
            <tbody>
                {
                    invoiceRows.map((invoiceRow, key) =>
                        <tr key={key}>
                            {
                                renderSelectionAreaColumns() ?
                                    <>
                                        <td className="table-data-link">{invoiceRow.description}</td>
                                        <td className="text-right text-nowrap table-data-link">{formatCurrency(invoiceRow.amount)}</td>
                                    </>
                                    :
                                    <>
                                        <td>{dateTimeToDateString(invoiceRow.treatmentDate)}</td>
                                        {
                                            showEntityColumn() ?
                                                <td>{renderEntityLink(invoiceRow)}</td>
                                                : null
                                        }
                                        <td className="table-data-link">{formatPersonalSecurityNumberAndOrganisationNumber(invoiceRow.personalSecurityId)}</td>
                                        <td className="table-data-link">{`${invoiceRow.patientTreatmentCode} - ${invoiceRow.patientTreatmentDescription}`}</td>
                                        <td className="text-right text-nowrap table-data-link">{formatCurrency(invoiceRow.price)} {invoiceRow.isCredit ? "(Kredit)" : ""}</td>
                                        <td style={{ width: "12%" }} className="text-right text-nowrap table-data-link">{formatCurrency(invoiceRow.amount)}</td>
                                    </>

                            }
                        </tr>
                    )
                }
            </tbody>
        </Table>
    )
}

